
jQuery(window).on('load',function () {
  setTimeout(() => {
    jQuery('.pre-carregamento').remove()
    jQuery('.slide-produtos').removeClass('hidden');
    jQuery('.slide-produtos').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: true,
      prevArrow:`<button type='button' class='prev-arrow arrows-custom'>
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="30" height="30" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M256 53.333C144.214 53.333 53.333 144.214 53.333 256S144.214 458.667 256 458.667 458.667 367.786 458.667 256 367.786 53.333 256 53.333zm36.48 251.521a21.5 21.5 0 0 1 0 30.292 21.635 21.635 0 0 1-30.294 0l-64-64a21.5 21.5 0 0 1 0-30.292l64-64a21.42 21.42 0 0 1 30.294 30.292L243.413 256z" data-name="chevron-circle-left-Filled" fill="#18181b" data-original="#000000" class=""></path></g></svg>
      </button>`,
      nextArrow:`<button type='button' class='next-arrow arrows-custom'>
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="30" height="30" x="0" y="0" viewBox="0 0 24 24" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path fill="#18181b" fill-rule="evenodd" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM10.293 9.707a1 1 0 1 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L12.586 12z" clip-rule="evenodd" data-original="#000000" class=""></path></g></svg>
      </button>`,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  }, 500);
});
